import { toast } from "react-toastify";
import { v4 as uuidv4 } from "uuid";

export const getError = (e) => {
  return e.errors
    ? e.errors[0].msg
    : e.response && e.response.data && e.response.data.errors
    ? e.response.data.errors[0].msg
    : e.response && e.response.data.message
    ? e.response.data.message
    : e.message;
};

export const getCesitlerText = (features, product) => {
  let text = "";
  features.map(
    (f) => (text += f.name + " ₺" + (f.price + product.price) + ", ")
  );
  return text;
};

export const barChartOptions = {
  title: "Toplam Satilan Urun Adeti veya Tutari",
  chartArea: { width: "50%" },
  hAxis: {
    title: "Toplam Miktar",
    minValue: 0,
  },
  vAxis: {
    title: "Urun",
  },
};

export const getTableDescriptionBreef = (description) => {
  return description.length > 10 ? description.slice(0, 10) : description;
};

export const getTableDescriptionBreefTablet = (description) => {
  return description.length > 5 ? description.slice(0, 4) : description;
};

export const getTableDescriptionBreef2 = (description) => {
  return description.length > 5 ? description.slice(0, 7) : description;
};

export const getCurrencyFormat = (num) => {
  return num.replace(/\d(?=(\d{3})+\.)/g, "$&,");
};

export const pieChartOptions = {
  title: "Toplam Satilan Urun Oranlari",
  is3D: true,
  legend: "none",
  pieSliceText: "label",
};

export const barChartLogScaledOptions = {
  title: "Toplam Satilan Urun Adeti veya Tutari",
  chartArea: { width: "50%" },
  hAxis: {
    title: "Toplam Miktar",
    minValue: 0,
    logScale: true,
  },
  vAxis: {
    title: "Urun",
  },
};

/* export const units = [
  { type: 'ADET-1', name: 'Adet' },
  { type: 'GRAM-1', name: 'Gram' },
  { type: 'KILO-1', name: 'Kilo' },
  { type: 'KILO-5', name: '5 Kilo' },
  { type: 'KOLI-12', name: 'Koli (12 Adet)' },
  { type: 'KOLI-24', name: 'Koli (24 Adet)' },
  { type: 'KOLI-30', name: 'Koli (30 Adet)' },
  { type: 'LITRE-1', name: 'Litre' },
  { type: 'LITRE-2', name: '2 Litre' },
  { type: 'LITRE-5', name: '5 Litre' },
  { type: 'KUTU-2', name: 'Kutu (2 Adet)' },
  { type: 'KUTU-3', name: 'Kutu (3 Adet)' },
  { type: 'KUTU-5', name: 'Kutu (5 Adet)' },
  { type: 'KUTU-10', name: 'Kutu (10 Adet)' },
  { type: 'KUTU-15', name: 'Kutu (15 Adet)' },
  { type: 'KUTU-20', name: 'Kutu (20 Adet)' },
]; */

export const units = [
  { type: "ADET-1", name: "Adet" },
  { type: "GRAM-1", name: "Gram" },
  { type: "KILO-1", name: "Kilo" },
  { type: "LITRE-1", name: "Litre" },
];

export const businessTypes = [
  { type: "CAFE", name: "Cafe" },
  { type: "RESTAURANT", name: "Restaurant" },
  { type: "CAFE_RESTAURANT", name: "Cafe & Restaurant" },
  { type: "PATISSERIE", name: "Patisserie" },
  { type: "CAFE_PATISSERIE", name: "Cafe & Patisserie" },
  { type: "FAST_FOOD", name: "Fast Food" },
  { type: "CAFE_FAST_FOOD", name: "Cafe & Fast Food" },
  { type: "TEA_HOUSE", name: "Tea House" },
  { type: "ICE_CREAM_PARLOR", name: "Ice Cream Parlor" },
  { type: "JUICE_BAR", name: "Juice Bar" },
  { type: "SMOOTHIE_BAR", name: "Smoothie Bar" },
  { type: "BAKERY_CAFE", name: "Bakery Cafe" },
  { type: "BRUNCH_SPOT", name: "Brunch Spot" },
];

export const membershipTypes = [
  { type: "3-FREE-MONTHS", name: "Üç ay ücretsiz deneme üyeliği" },
  { type: "1-FREE-MONTH", name: "Bir ay ücretsiz deneme üyeliği" },
  { type: "1-YEAR-GOLD", name: "Bir yıllık gold üyelik" },
];

export const expenseTypes = [
  {
    type: "GIDA",
    name: "Gıda",
    types: [
      { type: "MEYVESEBZE", name: "Meyveler ve Sebzeler" },
      { type: "PEYNIR", name: "Peynir Çeşitleri" },
      { type: "ET", name: "Et Çeşitleri" },
      { type: "ICECEK", name: "Alkolsiz İçecekler" },
      { type: "ALKOLLIICECEK", name: "Alkolli İçecekler" },
      { type: "KURUGIDA", name: "Kuru Gıda" },
      { type: "DIGER", name: "Diğer" },
    ],
  },
  {
    type: "MALZEME",
    name: "Malzeme",
    types: [
      { type: "SATINALMA", name: "Satınalma" },
      { type: "TAMIRAT", name: "Tamirat" },
      { type: "DIGER", name: "Diğer" },
    ],
  },
  {
    type: "FATURA",
    name: "Fatura",
    types: [
      { type: "ELEKTRIK", name: "Elektrik Faturası" },
      { type: "SU", name: "Su Faturası" },
      { type: "DOGALGAZ", name: "Doğalgaz Faturası" },
      { type: "INTERNET", name: "İnternet Faturası" },
      { type: "DIGER", name: "Diğer" },
    ],
  },
  {
    type: "KIRA",
    name: "Kira",
    types: [
      { type: "ISYERI_KIRASI", name: "İşyeri Kirası" },
      { type: "KONUT_KIRASI", name: "Konut Kirası" },
      { type: "DEPO_KIRASI", name: "Depo Kirası" },
      { type: "OFIS_KIRASI", name: "Ofis Kirası" },
      { type: "DIGER", name: "Diğer" },
    ],
  },
  {
    type: "VERGI",
    name: "Vergi",
    types: [
      { type: "GELIR_VERGISI", name: "Gelir Vergisi" },
      { type: "KURUMLAR_VERGISI", name: "Kurumlar Vergisi" },
      { type: "KDV", name: "Katma Değer Vergisi (KDV)" },
      { type: "STOPAJ", name: "Stopaj Vergisi" },
      { type: "DAMGA_VERGISI", name: "Damga Vergisi" },
      { type: "MTV", name: "Motorlu Taşıtlar Vergisi (MTV)" },
      { type: "CEVRE_TEMIZLIK_VERGISI", name: "Çevre Temizlik Vergisi" },
      { type: "EMLAK_VERGISI", name: "Emlak Vergisi" },
      { type: "OTV", name: "Özel Tüketim Vergisi (ÖTV)" },
      { type: "EGLENCE_VERGISI", name: "Eğlence Vergisi" },
      { type: "REKLAM_TABELA_VERGISI", name: "Reklam ve Tabela Vergisi" },
    ],
  },
  {
    type: "PERSONEL",
    name: "Personel",
    types: [
      { type: "AVANS", name: "Avans" },
      { type: "MAAS", name: "Maaş" },
      { type: "DIGER", name: "Diğer" },
    ],
  },
  {
    type: "HIZMET",
    name: "Hizmet Alımı",
    types: [
      { type: "KISIDEN", name: "Kişiden Alınan Hizmet" },
      { type: "ALET", name: "Araç İle Alınan Hizmet" },
      { type: "DIGER", name: "Diğer" },
    ],
  },
];
export const round2 = (num) => Math.round(num * 100 + Number.EPSILON) / 100;

export const getUnitLabel = (value) => {
  const unit = units.filter((u) => u.type === value);

  if (unit && unit[0]) {
    return unit[0].name;
  } else {
    return "";
  }
};

export const phoneFormat = (phone) => {
  return (
    "(" +
    phone.substr(0, 3) +
    ")" +
    " " +
    phone.substr(3, 3) +
    "-" +
    phone.substr(6)
  );
};

export const getExpenseTypeLabel = (value) => {
  const expense = expenseTypes.filter((u) => u.type === value);

  if (expense && expense[0]) {
    return expense[0].name;
  } else {
    return "";
  }
};

export const getExpenseSubTypes = (value) => {
  const expense = expenseTypes.filter((u) => u.type === value);

  if (expense && expense[0]) {
    return expense[0].types;
  } else {
    return "";
  }
};

export const getExpenseSubTypeLabel = (value1, value2) => {
  const expense = expenseTypes.filter((u) => u.type === value1);

  if (expense && expense[0]) {
    const subexpense = expense[0].types.filter((u) => u.type === value2);

    if (subexpense && subexpense[0]) {
      return subexpense[0].name;
    } else {
      return value2;
    }
  } else {
    return "";
  }
};

export const getMembershipLabel = (value) => {
  const membershipType = membershipTypes.filter((u) => u.type === value);

  if (membershipType && membershipType[0]) {
    return membershipType[0].name;
  } else {
    return "";
  }
};
export const getBusinessLabel = (value) => {
  const businessType = businessTypes.filter((u) => u.type === value);

  if (businessType && businessType[0]) {
    return businessType[0].name;
  } else {
    return "";
  }
};

export const diffDateMessage = (date1, date2) => {
  var diff = Math.floor(date1.getTime() - date2.getTime());
  diff = diff < 0 ? 0 : diff;
  var day = 1000 * 60 * 60 * 24;

  var days = Math.floor(diff / day);
  var months = Math.floor(days / 31);
  days = days - months * 31;

  if (months && days) {
    return months + " ay " + days + " gün";
  } else if (months && !days) {
    return months + " ay ";
  } else if (!months && days) {
    return days + " gün";
  } else {
    return "Süreniz dolmuştur!";
  }
};

export const getLocalTimeFormatted = (date) => {
  const dateString = new Date(date).toLocaleTimeString("tr-TR");
  const indx = dateString.indexOf(":", dateString.indexOf(":") + 1);
  return dateString.substring(0, indx);
};

export const loginHandler = (data, ctxDispatch, localStorage) => {
  const userInfoFetched = {
    ...data,
    isAdmin:
      data.role === "business_admin" ||
      data.role === "business_owner" ||
      data.role === "business_helpdesk",
    isUser: data.role === "business_user",
    isCustomer: data.role === "customer",
    isHelpDesk: data.role === "business_helpdesk",
    isBusinessOwner:
      data.role === "business_owner" || data.role === "business_helpdesk",
  };
  const clientCode = uuidv4();
  ctxDispatch({
    type: "USER_SIGNIN",
    payload: { ...userInfoFetched, clientCode },
  });
  localStorage.setItem(
    "userInfo",
    JSON.stringify({ ...userInfoFetched, clientCode })
  );
};

export const capitalize = (text) => {
  const arr = text.split(" ");

  for (var i = 0; i < arr.length; i++) {
    arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
  }

  return arr.join(" ");
};
export const createImage = (url) =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener("load", () => resolve(image));
    image.addEventListener("error", (error) => reject(error));
    image.setAttribute("crossOrigin", "anonymous"); // needed to avoid cross-origin issues on CodeSandbox
    image.src = url;
  });

export function getRadianAngle(degreeValue) {
  return (degreeValue * Math.PI) / 180;
}

/**
 * Returns the new bounding area of a rotated rectangle.
 */
export function rotateSize(width, height, rotation) {
  const rotRad = getRadianAngle(rotation);

  return {
    width:
      Math.abs(Math.cos(rotRad) * width) + Math.abs(Math.sin(rotRad) * height),
    height:
      Math.abs(Math.sin(rotRad) * width) + Math.abs(Math.cos(rotRad) * height),
  };
}

/**
 * This function was adapted from the one in the ReadMe of https://github.com/DominicTobias/react-image-crop
 */
export default async function getCroppedImg(
  imageSrc,
  pixelCrop,
  rotation = 0,
  flip = { horizontal: false, vertical: false }
) {
  const image = await createImage(imageSrc);
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");

  if (!ctx) {
    return null;
  }

  const rotRad = getRadianAngle(rotation);

  // calculate bounding box of the rotated image
  const { width: bBoxWidth, height: bBoxHeight } = rotateSize(
    image.width,
    image.height,
    rotation
  );

  // set canvas size to match the bounding box
  canvas.width = bBoxWidth;
  canvas.height = bBoxHeight;

  // translate canvas context to a central location to allow rotating and flipping around the center
  ctx.translate(bBoxWidth / 2, bBoxHeight / 2);
  ctx.rotate(rotRad);
  ctx.scale(flip.horizontal ? -1 : 1, flip.vertical ? -1 : 1);
  ctx.translate(-image.width / 2, -image.height / 2);

  // draw rotated image
  ctx.drawImage(image, 0, 0);

  // croppedAreaPixels values are bounding box relative
  // extract the cropped image using these values
  const data = ctx.getImageData(
    pixelCrop.x,
    pixelCrop.y,
    pixelCrop.width,
    pixelCrop.height
  );

  // set canvas width to final desired crop size - this will clear existing context
  canvas.width = pixelCrop.width;
  canvas.height = pixelCrop.height;

  // paste generated rotate image at the top left corner
  ctx.putImageData(data, 0, 0);

  // As Base64 string
  // return canvas.toDataURL('image/jpeg');

  // As a blob
  return new Promise((resolve, reject) => {
    canvas.toBlob((file) => {
      resolve(URL.createObjectURL(file));
    }, "image/jpeg");
  });
}

export function toTurkish(text) {
  var trMap = {
    çÇ: "c",
    ğĞ: "g",
    şŞ: "s",
    üÜ: "u",
    ıİ: "i",
    öÖ: "o",
  };
  for (var key in trMap) {
    text = text.replace(new RegExp("[" + key + "]", "g"), trMap[key]);
  }
  return text
    .replace(/[^-a-zA-Z0-9\s]+/gi, "")
    .replace(/\s/gi, ".")
    .replace(/[-]+/gi, ".")
    .toLowerCase();
}

function degreesToRadians(degrees) {
  return (degrees * Math.PI) / 180;
}

export function distanceInKmBetweenEarthCoordinates(lat1, lon1, lat2, lon2) {
  var earthRadiusKm = 6371;

  var dLat = degreesToRadians(lat2 - lat1);
  var dLon = degreesToRadians(lon2 - lon1);

  lat1 = degreesToRadians(lat1);
  lat2 = degreesToRadians(lat2);

  var a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return earthRadiusKm * c;
}

export const pickerLang = {
  months: [
    "Ocak",
    "Şubat",
    "Mart",
    "Nisan",
    "Mayıs",
    "Haziran",
    "Temmuz",
    "Ağustos",
    "Eylül",
    ",Ekim",
    "Kasım",
    "Aralık",
  ],
  from: "From",
  to: "To",
};

export const getMonthlyStocksReFormatted = (stocks) => {
  const stocksRe = [];

  for (let index = 0; index < stocks.length; index++) {
    const stock = stocks[index];
    let found = false;
    for (let index2 = 0; index2 < stocksRe.length; index2++) {
      const stockRe = stocksRe[index2];
      if (stockRe.product._id.toString() === stock.product._id.toString()) {
        found = true;

        stockRe.product.features.push({
          feature: stock.featureName,
          featureId: stock.feature,
          cost: (stock.cost || stock.product.cost || 0) * stock.amount,
          itemCost: stock.cost || stock.product.cost || 0,
          amount: stock.amount,
        });
        stockRe.totalAmount += stock.amount;
        stockRe.itemCost = stock.cost || stock.product.cost || 0;
        stockRe.totalCost +=
          stock.amount * (stock.cost || stock.product.cost || 0);
        break;
      }
    }
    if (!found) {
      stocksRe.push({
        product: {
          ...stock.product,
          features: [
            {
              feature: stock.featureName,
              featureId: stock.feature,
              cost: (stock.cost || stock.product.cost || 0) * stock.amount,
              itemCost: stock.cost || stock.product.cost || 0,
              amount: stock.amount,
            },
          ],
        },
        totalAmount: stock.amount,
        totalCost: stock.amount * (stock.cost || stock.product.cost || 0),
        itemCost: stock.cost || stock.product.cost || 0,
      });
    }
  }

  return stocksRe;
};

export const applyPreviuosMonthStock = (stocks, previousMonthStock) => {
  for (let m = 0; m < stocks.length; m++) {
    const stock = stocks[m];
    for (let i = 0; i < previousMonthStock.length; i++) {
      const stockPrevious = previousMonthStock[i];
      if (
        stockPrevious.product._id.toString() === stock.product._id.toString()
      ) {
        stock.previousTotalAmount = stockPrevious.totalAmount;
        stock.previousTotalCost = stockPrevious.totalCost;
        stock.diffCost = stock.totalCost - stockPrevious.totalCost;
        stock.diffAmount = stock.totalAmount - stockPrevious.totalAmount;

        for (let j = 0; j < stock.product.features.length; j++) {
          const feature = stock.product.features[j];
          for (let k = 0; k < stockPrevious.product.features.length; k++) {
            const featurePrevious = stockPrevious.product.features[k];
            if (
              feature.featureId?.toString() ===
              featurePrevious.featureId?.toString()
            ) {
              feature.previousCost = featurePrevious.cost;
              feature.previousAmount = featurePrevious.amount;
              feature.diffCost = feature.cost - featurePrevious.cost;
              feature.diffAmount = feature.amount - featurePrevious.amount;
            }
          }
        }
      }
    }
  }

  return stocks;
};

export const hashCode = (str) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  return Math.abs(hash); // Ensure non-negative values
};

export function replacer(key, value) {
  if (value instanceof Map) {
    return {
      dataType: "Map",
      value: Array.from(value.entries()), // or with spread: value: [...value]
    };
  } else {
    return value;
  }
}

export function reviver(key, value) {
  if (typeof value === "object" && value !== null) {
    if (value.dataType === "Map") {
      return new Map(value.value);
    }
  }
  return value;
}

export function fixScrollToBottom(id) {
  var elem = document.getElementById(id);
  if (elem && elem.scrollHeight) {
    elem.scrollTop = elem.scrollHeight;
  }
}

export function uniqueByKeepLast(data, key) {
  return [...new Map(data.map((x) => [key(x), x]))].values();
}

const getMonthDiff = (d1, d2) => {
  let months;
  months = (d2.getFullYear() - d1.getFullYear()) * 12;
  months -= d1.getMonth();
  months += d2.getMonth();
  return months <= 0 ? 0 : months;
};

export const getTimeExpr = (lastSeen, fromDate) => {
  const date1 = fromDate || new Date();
  const date2 = lastSeen;

  const monthDiff = getMonthDiff(date1, date2);

  if (monthDiff > 12) {
    return Math.floor(monthDiff / 12) + " yıl";
  }

  if (monthDiff > 0) {
    return monthDiff + " ay";
  }

  const diffTime = Math.abs(date1 - date2);
  const dayDiff = Math.floor(diffTime / (1000 * 60 * 60 * 24));

  if (dayDiff > 0) {
    return dayDiff + " gün";
  }

  const hoursDiff = Math.floor(diffTime / (1000 * 60 * 60));

  if (hoursDiff > 0) {
    return hoursDiff + " saat";
  }

  const minuteDiff = Math.floor(diffTime / (1000 * 60));

  if (minuteDiff > 0) {
    return minuteDiff + " dakika";
  }

  return "Şimdi";
};

export const turkishCurrencyFormatter = (amount) => {
  // Format the number as Turkish currency
  const formattedAmount = new Intl.NumberFormat("tr-TR", {
    style: "currency",
    currency: "TRY",
  }).format(amount);

  return formattedAmount;
};

export const turkishCurrencyFormatterNoPrecision = (amount) => {
  const formattedAmount = new Intl.NumberFormat("tr-TR", {
    style: "currency",
    currency: "TRY",
  }).format(amount);

  return formattedAmount.substring(0, formattedAmount.length - 3);
};

export const getWeekNumber = (date) => {
  const startOfYear = new Date(date.getFullYear(), 0, 1);
  const diffInDays = (date - startOfYear) / (1000 * 60 * 60 * 24);
  const weekNumber = Math.ceil((diffInDays + startOfYear.getDay() + 1) / 7);
  return weekNumber;
};

export const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const getTimeDifferenceAsMinutesAndHours = (startDate, endDate) => {
  // Calculate the difference in milliseconds
  const diffMs = endDate - startDate;

  // Convert milliseconds to hours and minutes
  const hours = Math.floor(diffMs / (1000 * 60 * 60));
  const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

  return `${hours} saat ve ${minutes} dakika`;
};

export const getTableType = (tableTypes, tableTypeId) => {
  return (tableTypes || []).find((u) => u._id === tableTypeId);
};

export const formatTurkishLira = (amount) => {
  const formatter = new Intl.NumberFormat("tr-TR", {
    style: "currency",
    currency: "TRY",
    minimumFractionDigits: 2, // Ensures two decimal places
    maximumFractionDigits: 2,
  });

  return formatter.format(amount);
};

export const validatePassword = (password, setPasswordStrength) => {
  if (password.length < 6) {
    setPasswordStrength("Şifre en az altı karakter olmalıdır");
  } else if (!/[A-Z]/.test(password)) {
    setPasswordStrength("Şifre en az bir büyük harf içermelidir");
  } else if (!/[a-z]/.test(password)) {
    setPasswordStrength("Şifre en az bir küçük harf içermelidir");
  } else if (!/[0-9]/.test(password)) {
    setPasswordStrength("Şifre en az bir rakam içermelidir");
  } else if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
    setPasswordStrength("Şifre en az bir özel karakter içermelidir");
  } else {
    setPasswordStrength("Şifre güçlü");
  }
};

export const removeNullFields = (obj) => {
  return Object.fromEntries(
    Object.entries(obj).filter(([_, value]) => value !== null)
  );
};

export const notifyError = (message) => {
  toast.error(message, {
    autoClose: 10000,
  });
};

export const getPrintAreaHtml = (
  userInfo,
  summaryCartItems,
  cart,
  domainName
) => {
  const businessLabel = getBusinessLabel(userInfo.businessType);

  const tableRows = summaryCartItems
    .map((item) => {
      const featureText = item.feature ? `${item.feature.name} ` : "";
      const price = turkishCurrencyFormatterNoPrecision(
        item.price + (item.feature ? item.feature.price : 0)
      );

      return `
        <tr>
          <td style="width: 10%; text-align: left;">${item.quantity}</td>
          <td style="width: 70%; text-align: left;">${featureText}${
        item.name.length > 20 ? item.name.substring(0, 22) : item.name
      }</td>
          <td style="width: 20%; text-align: right;">${price}</td>
        </tr>
      `;
    })
    .join("");

  const footer = `
    <div style="text-align: right; margin-top: 20px; font-weight: bold; color: #000000;">
      Toplam (${cart.totalCount} Adet)
      <span>${turkishCurrencyFormatterNoPrecision(cart.totalPrice)}</span>
      <div style="text-align:center;">
        <div>&nbsp;</div>
        <div>Bizi tercih ettiğiniz için</div>
        <div>teşekkür ederiz.</div>
        <div>Yeniden görüşmek dileğiyle!</div>
        <div>${domainName}</div>
      </div>
    </div>
  `;

  const printAreaHtml = `
    <div style="font-size: 20px; font-weight: bold; padding:40px; color: #000000" >
      <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: center;">
        <div>
          <span>${userInfo.businessName || ""}</span>
        </div>
        <div>${businessLabel}</div>
      </div>
      <table style="width: 100%; border-collapse: collapse; margin-top: 10px;">
        <tbody>
          ${tableRows}
        </tbody>
      </table>
      ${footer}
    </div>
  `;

  return printAreaHtml;
};

export const formatBytes = (bytes) => {
  if (bytes === 0) return "0 Bytes";

  const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
  const i = Math.floor(Math.log(bytes) / Math.log(1024)); // Determine the unit
  const convertedSize = bytes / Math.pow(1024, i); // Convert bytes to appropriate unit

  // Determine the formatting logic
  const formattedSize =
    i < 2 ? Math.floor(convertedSize) : convertedSize.toFixed(2); // No decimals for Bytes/KB, 2 decimals for MB/GB/TB

  return `${formattedSize} ${sizes[i]}`;
};
